<template>
    <div>
        <div
            class="flex flex-wrap items-center expense-header justify-between md:px-8 px-6 sm:pb-2 sm: pt-6 d-theme-dark-bg"
        >
            <div class="flex mb-4">
                <div class="flex items-center">
                    <vx-back-button v-if="details.id" />
                    <h4 style="text-align: center">
                        {{
                            details.id
                                ? `${details.firstName} ${details.lastName} | ID: ${details.id}`
                                : 'New User'
                        }}
                    </h4>
                </div>
            </div>
        </div>

        <crm-content>
            <vx-card>
                <div class="vs-row w-full flex">
                    <div class="vs-col w-1/2">
                        <vx-input
                            class="w-full"
                            label="First Name"
                            name="First Name"
                            v-model="details.firstName"
                            placeholder="Enter First Name"
                        />
                    </div>
                    <div class="vs-col w-1/2 pl-5">
                        <vx-input
                            class="w-full"
                            label="Last Name"
                            name="Last Name"
                            v-model="details.lastName"
                            placeholder="Enter Last Name"
                        />
                    </div>
                </div>

                <div class="vs-row w-full flex">
                    <div class="vs-col w-1/2">
                        <vx-input
                            class="w-full"
                            label="Email Address"
                            name="Email Address"
                            v-model="details.emailAddress"
                            placeholder="Enter Email Address"
                        />
                    </div>
                </div>

                <vs-divider></vs-divider>

                <div v-if="details.id">
                    <div class="vs-row w-full flex flex-inline">
                        <vx-elastic-suggest
                            label="Role"
                            name="Role"
                            placeholder="Select a Role"
                            class="w-1/2 mr-2"
                            v-model="selectedRole"
                            :showOnFocus="true"
                            :search_groups="filteredRoleOptions_group"
                            show-on-focus
                            select-like
                        >
                        </vx-elastic-suggest>

                        <vs-button @click="assignRole" class="my-6" id="textForBtn"
                            >Assign Role</vs-button
                        >
                    </div>

                    <div class="vs-row w-full flex">
                        <div class="vs-col w-full my-5">
                            <div class="mb-2">
                                <label>Assigned Roles</label>
                            </div>
                            <vx-client-side-table
                                :data="details.roles"
                                :columns="roleColumns"
                                class="ml-2 dealreg-table"
                                id-key="id"
                            >
                                <template v-slot:Remove="{ row }">
                                    <div class="flex flex-inline">
                                        <vx-action-icon
                                            icon="TrashIcon"
                                            color="danger"
                                            tooltip="Remove Role"
                                            class="mr-3"
                                            @click.stop="removeRole(row)"
                                        />
                                    </div>
                                </template>
                            </vx-client-side-table>
                        </div>
                    </div>

                    <vs-divider></vs-divider>
                </div>

                <div class="w-full mt-5 flex">
                    <div class="w-full flex justify-end">
                        <vs-button class="ml-5" @click="save">
                            <span>{{ userId ? 'Update' : 'Save' }}</span>
                        </vs-button>
                    </div>
                </div>
            </vx-card>
        </crm-content>
    </div>
</template>

<script>
import CrmContent from '../../crm/components/CrmContent.vue'
import { mapParams } from '@/plugins/mappers'
import { mapGetters } from 'vuex'

export default {
    name: 'user-details',
    components: {
        CrmContent
    },
    props: {
        userId: {
            type: [Number, String],
            required: false
        }
    },
    computed: {
        ...mapGetters({
            userProfile: 'user/profile',
            roles: 'maarima/roles'
        }),
        currentBrokerId() {
            return this.$store.getters['auth/broker_id']
        },
        isStatusImported() {
            return this.details.status == this.STATUS.Imported
        },
        isStatusReleased() {
            return (
                this.details.status == this.STATUS.Released ||
                this.details.status == this.STATUS.CannotBeManagedAtAASite
            )
        },
        roleColumns() {
            return [
                { title: 'ID', sort: 'id', value: 'id' },
                { title: 'Name', sort: 'name', value: 'name' },
                { title: 'Remove', value: '' }
            ]
        },
        filteredRoleOptions() {
            if (this.details.roles && this.details.roles.length > 0) {
                var filtered = this.roles.filter((option) => {
                    return !this.details.roles.some((role) => role.name === option.name)
                })

                return filtered
            }
            return this.roles
        },
        filteredRoleOptions_group() {
            return {
                Role: {
                    // searchUrl: '/maarima/GeneralPractitioner',
                    data: this.filteredRoleOptions,
                    idfield: 'id',
                    searchOn: (b) => `${b.name}`,
                    displayText: 'name'
                }
            }
        }
    },
    data() {
        return {
            details: {
                firstName: null,
                lastName: null,
                emailAddress: null,
                active: false,
                roles: []
            },
            selectedRole: null
        }
    },
    methods: {
        async save() {
            if (await this.validate()) {
                if (this.details.id) {
                    await this.edit()
                } else {
                    await this.add()
                }
            }
        },
        async edit() {
            try {
                this.loading = true

                var response = await this.$api.users.update(this.details)
                this.notifySuccess('Updated successfully', 'User Updated successfully.', 5000)
                await this.fetchData()
            } catch (err) {
                this.notifyError('Error', `Error message: ${err}`, 5000)
            } finally {
                this.loading = false
            }
        },

        async add() {
            try {
                this.loading = true

                var response = await this.$api.users.create(this.details)
                this.notifySuccess('Created successfully', 'User created successfully.', 5000)
                this.$router.replace(`/admin/users/${response.id}`)
                this.details = await this.$api.users.fetchById(response.id)
            } catch (err) {
                this.notifyError('Error', `Error message: ${err}`, 5000)
            } finally {
                this.loading = false
            }
        },

        async fetchData() {
            if (this.userId) {
                this.loading = true
                try {
                    this.details = await this.$api.users.fetchById(this.userId)
                } catch (e) {
                    if (e.response.status == 403) {
                        this.$router.replace({ name: '403' })
                    }
                    if (e.response.status == 404) {
                        this.$router.replace({ name: '404' })
                    }
                } finally {
                    this.loading = false
                }
            }
        },

        async assignRole() {
            try {
                if (!this.selectedRole) {
                    this.notifyError('Error', `A role must be selected`, 5000)
                    return
                }

                var response = await this.$api.users.assignRole(this.userId, this.selectedRole)

                this.selectedRole = null
                this.notifySuccess('Success', `Saved role successfully`, 5000)
                this.fetchData()
            } catch (error) {
                let errors = ''
                try {
                    errors = error.response.data.title
                } catch (e) {
                    errors = 'An Unknown Error Occurred..'
                }
                this.notifyError('Error', `Something Went Wrong: ${errors}.`, 5000)
            } finally {
            }
        },

        async removeRole(role) {
            try {
                var response = await this.$api.users.removeRole(this.userId, role.id)

                this.selectedRole = null
                this.notifySuccess('Success', `Removed role successfully`, 5000)
                this.fetchData()
            } catch (error) {
                let errors = ''
                try {
                    errors = error.response.data.title
                } catch (e) {
                    errors = 'An Unknown Error Occurred..'
                }
                this.notifyError('Error', `Something Went Wrong: ${errors}.`, 5000)
            } finally {
            }
        }
    },
    async mounted() {
        await this.fetchData()
    }
}
</script>
<style scoped>
#textForBtn {
    height: 40px;
    font-size: 1rem;
}
</style>
